
const Back = () => {
    return (
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5 12L4.29289 11.2929L3.58579 12L4.29289 12.7071L5 12ZM17 13C17.5523 13 18 12.5523 18 12C18 11.4477 17.5523 11 17 11V12V13ZM9 8L8.29289 7.29289L4.29289 11.2929L5 12L5.70711 12.7071L9.70711 8.70711L9 8ZM5 12L4.29289 12.7071L8.29289 16.7071L9 16L9.70711 15.2929L5.70711 11.2929L5 12ZM5 12V13H17V12V11H5V12Z" fill="#33363F" />
        </svg>
    )
}

export default Back